import styled from 'styled-components'
import { overloadColor } from '@/utils/style'

type Props = {
  label: string
  color: string
  hours?: string
  isIssue?: boolean
  isOtherCondition?: boolean
}

const Wrapper = styled.div<{ color: string }>`
  display: inline-flex;
  align-items: center;
  border: 2px solid ${props => overloadColor(props.color)};
  border-radius: 6px;
  font-size: 14px;
  padding: 7px 16px 7px 12px;
  color: ${props => overloadColor(props.color)};
`

const ConditionWrapper = styled.div<{ color: string }>`
  display: inline-flex;
  align-items: center;
  text-align: center;
  border-radius: 6px;
  padding: 7px 16px 7px 12px;
  background-color: ${props => overloadColor(props.color)};
  color: #cfecfd;
`

export const LegendItem = ({
  label,
  hours,
  color,
  isIssue = false,
  isOtherCondition = false,
}: Props) => {
  if (isIssue || isOtherCondition) {
    return (
      <ConditionWrapper color={color}>
        <span>{label}</span>
      </ConditionWrapper>
    )
  }

  return (
    <Wrapper color={color}>
      <span
        style={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: overloadColor(color),
          display: 'inline-block',
          marginRight: '6px',
        }}
      ></span>
      <span>
        <strong>{label}</strong> {hours}
      </span>
    </Wrapper>
  )
}
